<template>
  <div>
    <logged-in-header />
    <reward-program-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import RewardProgramPanel from "../components/reward-program/RewardProgramPanel";

export default {
  components: {
    loggedInHeader,
    RewardProgramPanel
  }
};
</script>
